export const machineWatcher = (machine, name, dbg) => {
  if (machine) {
    dbg("Starting watching ".concat(name));
    machine.onChange(ctx => {
      dbg('ctx', ctx);
    }).onTransition(state => {
      dbg('State:' + machine.id, state.value);
    }).onEvent(event => {
      dbg('Event:' + machine.id, event);
    }).onSend(event => {
      dbg('Send:' + machine.id, event);
    });
  }
};